import React from 'react';
import { motion } from 'framer-motion';
import { PILLARS } from './oathTheme';

const GAINS = [
  { img: '/oath/realm_courage.png', title: 'Confidence', text: 'Keep promises to yourself' },
  { img: '/oath/gain_gratitude.png', title: 'Gratitude', text: 'Train your mind to see good' },
  { img: '/oath/gain_focus.png', title: 'Focus', text: 'Shatter every distraction' },
];

/* Purpose screen — fits one window, no scrolling. */
export const OathIntro = ({ onStart }) => (
  <motion.div className="fixed inset-0 z-[260] flex flex-col overflow-hidden" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
    style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(139,63,191,0.35), #05050A 60%), #05050A', paddingTop: 'max(var(--safe-area-inset-top, 0px), 16px)', paddingBottom: 'calc(var(--safe-area-inset-bottom, 0px) + 16px)' }} data-testid="oath-intro">
    <div className="flex-1 min-h-0 w-full max-w-md mx-auto px-6 flex flex-col justify-evenly">
      <div className="text-center">
        <p className="font-['Outfit'] text-[9px] tracking-[0.4em] uppercase text-[#D4AF37]/70">The Daily Ritual of the Strong</p>
        <motion.h1 initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
          className="font-['Cinzel'] text-[clamp(34px,6vh,48px)] leading-none mt-2" style={{ color: '#FFE9A0', textShadow: '0 0 30px rgba(212,175,55,0.6)' }}>OATH</motion.h1>
        <p className="font-['Cormorant_Garamond'] italic text-[clamp(14px,2.1vh,17px)] text-white/75 mt-2 leading-snug">Three minutes a day. Keep your word, feed your gratitude, lock your focus — rise stronger.</p>
      </div>
      <div className="space-y-[1.2vh]">
        {PILLARS.map((p, i) => (
          <motion.div key={p.id} initial={{ x: -20, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ delay: 0.15 + i * 0.1 }}
            className="rounded-2xl px-4 py-[1.1vh] flex gap-3 items-center" style={{ border: `1px solid ${p.accent}50`, background: `${p.accent}10` }}>
            <span className="font-['Cinzel'] text-lg w-7 text-center" style={{ color: p.accent }}>{p.numeral}</span>
            <div className="min-w-0">
              <p className="font-['Cinzel'] text-[13px]" style={{ color: p.light }}>{p.name}</p>
              <p className="font-['Outfit'] text-[11px] text-white/55 leading-tight">{p.tagline}</p>
            </div>
          </motion.div>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {GAINS.map((g, i) => (
          <motion.div key={g.title} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 + i * 0.1 }} className="text-center">
            <div className="flex justify-center"><img src={g.img} alt="" draggable={false} style={{ width: 46, height: 46, objectFit: 'contain' }} /></div>
            <p className="font-['Outfit'] text-xs text-white mt-1">{g.title}</p>
            <p className="font-['Outfit'] text-[10px] text-white/45 leading-tight">{g.text}</p>
          </motion.div>
        ))}
      </div>
      <p className="font-['Outfit'] text-[11px] text-white/60 text-center">Do all three in one day to forge the <span className="text-[#FFE9A0]">Daily Crown</span> and climb from Initiate to Emperor.</p>
      <motion.button type="button" onClick={onStart} whileTap={{ scale: 0.95 }} data-testid="oath-intro-start"
        className="w-full py-[1.8vh] rounded-full font-['Cinzel'] tracking-[0.3em] text-sm text-black flex-shrink-0"
        style={{ background: 'linear-gradient(135deg, #FFE9A0, #D4AF37 50%, #B8860B)', boxShadow: '0 0 30px rgba(212,175,55,0.5)' }}>
        I AM READY
      </motion.button>
    </div>
  </motion.div>
);

export default OathIntro;
